import { Button } from 'antd'
import React from 'react'
import { RefreshIcon } from 'src/assets/icons'
import { useTableContext } from './TableProvider'
import { useTranslation } from 'react-i18next'

const TableResetButton: React.FC = () => {
  const { onResetView, isUpdatingSetting, displayResetButton = true, disableTableControl = false } = useTableContext()
  const { t } = useTranslation()
  if (!displayResetButton || disableTableControl) {
    return <React.Fragment />
  }
  return (
    <Button
      id='reset-button'
      icon={<RefreshIcon />}
      onClick={onResetView}
      loading={isUpdatingSetting}
      disabled={isUpdatingSetting}
      style={{ fontWeight: 600, fontSize: 14 }}
    >
      {t('OverallFunctionality:table.search.reset_view_button_title')}
    </Button>
  )
}

export default TableResetButton
